/* eslint-disable max-lines-per-function */
import { Form, Formik, FormikConfig } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "components/haven-design/buttons";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { Card } from "components/haven-design/card";
import { HavenConnectLoginLogo, BackToLogin, LoneGrid, LoginCardTitle, PasswordValidations } from "components/login/components/shared-components";
import { PasswordValidationType, validatePassword } from "components/login/utils";
import loginCss from "components/login/components/Login.module.css";
import { loginAuthColumnSx } from "components/login/components/styles";
import { useChooseNewPassword } from "./actions";
import { loginStyles } from "./styles";

const ChoosePassword: React.FC = () => {
  const navigate = useNavigate();
  const { token = "" } = useParams<{ token: string }>();
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<PasswordValidationType[]>([]);
  const chooseNewPassword = useChooseNewPassword();

  useEffect(() => {
    setErrors(validatePassword(password));
  }, [password]);

  const onSubmit: FormikConfig<{ password: string }>["onSubmit"] = async (values, handlers) => {
    await chooseNewPassword(token || "", values.password)
      .then((returnUrl: string) => {
        // root view will redirect to correct home page
        navigate(returnUrl || "/");
      })
      .catch((error: string) => handlers.setFieldError("password", `${error}`));
  };

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid size={{ xs: 12 }}>
        <HavenConnectLoginLogo />
      </Grid>
      <Card>
        <LoneGrid>
          <LoginCardTitle title={<>&nbsp;&nbsp;Choose a new password&nbsp;&nbsp;</>} />
          <Formik
            initialValues={{ password }}
            onSubmit={onSubmit}
            validationSchema={yup.object().shape({
              password: yup.string().required().validPassword(),
            })}
            enableReinitialize={true}
          >
            <Form>
              <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
                <InputWithErrorLabel
                  name="password"
                  label="New Password"
                  type="password"
                  style={loginStyles.loginInput}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Grid>
              <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
                <PasswordValidations errors={errors} />
              </Grid>
              <Grid size={{ xs: 12 }}><br/></Grid>
              <LoneGrid>
                <Grid size={{ xs: 12 }} sx={loginAuthColumnSx}>
                  <Button
                    disabled={errors.length > 0}
                    size="L"
                    color="primary"
                    type="submit"
                    fullWidth
                    className={loginCss.loginButton}
                    style={loginStyles.btn}
                  >
                    Save and Log In
                  </Button>
                </Grid>
              </LoneGrid>

              <BackToLogin />
            </Form>
          </Formik>
        </LoneGrid>
      </Card>
    </Grid>
  );
};

export default ChoosePassword;
